export default "__VITE_ASSET__CKMM67Ci__"